export default __webpack_public_path__ + "static/media/main-bar-group-lyte@2x.8be042b9.png";